"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _usePresenterAddedToChimeSLI = require("./usePresenterAddedToChimeSLI");
Object.keys(_usePresenterAddedToChimeSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _usePresenterAddedToChimeSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _usePresenterAddedToChimeSLI[key];
    }
  });
});